export default function DividerGradient() {
  return <div className="divider-gradient"></div>
}
